import { Link } from "@reach/router";
import React from "react";
import styled from "styled-components";
import Logo from "../assets/images/ttc-logo.svg";
import bg from "../assets/images/bg-ttc.svg";
// import Logo from "../assets/images/Logo.js";
import { t } from "../lang";

const data = [
  // {
  //   color: "#002856",
  //   title: "",
  //   image: Logo,
  //   invert: false,link: "/#",
  // },

  // {
  //   color: "#008AAB",
  //   title: "التسجيل في خدمة النقل",
  //   image: "https://www.svgrepo.com/show/324203/edit-pencil-write.svg",
  //   invert: true,
  //   link: "/usertype",
  // },
  {
    color: "#202020",
    title: "تواصل معنا",
    image: "https://www.svgrepo.com/show/304548/call.svg",
    invert: true,
    link: "/contact_us",
  },
  {
    color: "#E74F3D",
    title: "النقل الترددي",
    image: "https://www.svgrepo.com/show/171195/arrows.svg",
    invert: true,
    link: "/service1",
  },
  {
    color: "#002856",
    title: "خدمة النقل للمصانع",
    image: "https://www.svgrepo.com/show/35304/up-arrow.svg",
    invert: true,
    link: "/service2",
  },

  {
    color: "#b4b4b4",
    title: "عن الشركة",
    image: "https://www.svgrepo.com/show/324201/status-info-information.svg",
    invert: true,
    link: "/about",
  },

  // {
  //   color: "#929292",
  //   title: "أخبار",
  //   image: "https://www.svgrepo.com/show/209175/newspaper-news.svg",
  //   invert: true,
  //   link: "/#",
  // },
];
const Home = (props: any) => {
  return (
    <Main className="App">
      <header className="App-header">
        <Bubble
          style={{
            position: "absolute",
            top: -185,
            left: 0,
            zIndex: 1000,
            minWidth: "auto",
          }}
        >
          <BubbleContainer>
            <Spacer />
            <LogoImage src={Logo} style={{ height: 110 }} />
          </BubbleContainer>
        </Bubble>


        <Demo  >
          نسخة تجريبية
        </Demo>

        <AppTitle>
          مشروع نقل المدن الصناعية <Span>بالشراكة مع هيئة مدن الصناعية</Span>
        </AppTitle>



        <Spacer />

        <BubblesContainer>
          {data.map((item) => (
            <Link to={item.link}>
              <Bubble color={item.color}>
                <BubbleContainer>
                  <LogoImage src={item.image} invert={item.invert} />
                  <Title>{item.title}</Title>
                </BubbleContainer>
              </Bubble>
            </Link>
          ))}
        </BubblesContainer>

        <Spacer />
      </header>
    </Main>
  );
};

const Span = styled.div`
  color: #333;
  font-size: 0.6em;
  font-weight: normal;
`;
const AppTitle = styled.h1`
  color: #333;
  font-size: 1.6em;
  padding-top:160px;
`;
const Main = styled.div`
  background-image: url(${bg});
  background-color: #fff;
  overflow: auto;
  height: 100vh;
`;

const Spacer = styled.div`
  height: 200px;
`;

const BubblesContainer = styled.div`
  display: grid;
  margin-top: 10px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  
  @media (max-width: 768px) {
    margin-top: -170px;

    grid-template-columns: 1fr;
    grid-column-gap: 10px;
  grid-row-gap: 10px;
  }
`;
const Bubble = styled.div`
  /* transform: rotate(-40deg); */
  background: ${(props) => (props.color ? props.color : "#002856")};
  /* border-radius: 300.5px 300.5px 300.5px 0; */
  min-width: 270px;
  min-height: 300px;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 500ms;
  &:hover {
    transform: scale(1.1) rotate(-5deg);
    box-shadow: 0 0 7px 7px rgba(0, 0, 0, 0.2);
  }
`;

const LogoImage = styled.img<any>`
  height: 70px;
  filter: ${(props) => (props.invert ? "invert(100%)" : "")};
`;

const BubbleContainer = styled.div`
  /* transform: rotate(40deg); */
`;

const Title = styled.h1`
  font-size: 0.8em;
  margin: 0.1em;
`;
const Demo = styled.h1`
  font-size: 1em;
  margin: 0.1em;
  color:red;
  position: absolute;
  top: 30px;
  right:30px;
`;

export default Home;
